import { __extends } from "tslib";
/* eslint-disable jsx-a11y/aria-activedescendant-has-tabindex */
// DS: DS3.1
import React from 'react';
import classnames from 'classnames';
import bindOwnClassnamesWithSkin from '../utils/bindOwnClassnamesWithSkin';
import InputLayout from '../InputLayout';
import IconArrowUp from '../Icons/ArrowUp';
import IconArrowDown from '../Icons/ArrowDown';
import { IconSize } from '../Icons/IconWrap';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import BiInput from '@wix/da-bi/pkg/Components/BiInput';
import s from './Input.scss';
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFocused: false,
            isAutofilled: false,
        };
        _this.checkForBrowserAutofill = function () {
            if (_this.input &&
                _this.input.value !== _this.props.value &&
                _this.input.value !== _this.oldInputValue) {
                _this.oldInputValue = _this.input.value;
                if (_this.props.onChange) {
                    _this.props.onChange(_this.input.value, {
                        target: _this.input,
                    });
                }
            }
            setTimeout(_this.checkForBrowserAutofill, 100);
        };
        _this.ref = function (input) {
            _this.input = input;
            if (_this.props.refInput) {
                _this.props.refInput(input);
            }
        };
        _this.triggerChange = function (value) {
            var _a = _this.props, minValue = _a.minValue, maxValue = _a.maxValue;
            var validValue = value;
            if (minValue !== undefined) {
                validValue = Math.max(value, minValue);
            }
            if (maxValue !== undefined) {
                validValue = Math.min(validValue, maxValue);
            }
            _this.input.value = validValue.toString();
            var event = new Event('input', { bubbles: true });
            _this.input.dispatchEvent(event);
        };
        _this.handleIncrement = function () {
            var oldValue = parseFloat(_this.input.value);
            oldValue = !isNaN(oldValue) ? oldValue : 0;
            var _a = _this.props.step, step = _a === void 0 ? 1 : _a;
            _this.triggerChange(oldValue + step);
        };
        _this.handleDecrement = function () {
            var oldValue = parseFloat(_this.input.value);
            oldValue = !isNaN(oldValue) ? oldValue : 0;
            var _a = _this.props.step, step = _a === void 0 ? 1 : _a;
            _this.triggerChange(oldValue - step);
        };
        _this.onFocus = function (event) {
            _this.setState({ isFocused: true });
            if (_this.props.onFocus) {
                _this.props.onFocus(event);
            }
        };
        _this.onBlur = function (event) {
            _this.setState({ isFocused: false });
            if (_this.props.onBlur) {
                _this.props.onBlur(event);
            }
        };
        _this.onChange = function (event) {
            var value = event.target.value;
            if (_this.props.onChange) {
                _this.props.onChange(value, event);
            }
        };
        _this.onKeyUp = function (event) {
            var _a = _this.props, onKeyUp = _a.onKeyUp, onEnter = _a.onEnter, onEscape = _a.onEscape;
            onKeyUp && onKeyUp(event);
            if (event.key === 'Enter') {
                onEnter && onEnter(event);
            }
            else if (event.key === 'Escape') {
                onEscape && onEscape(event);
            }
        };
        _this.s = bindOwnClassnamesWithSkin(s, props.skin);
        return _this;
    }
    Input.prototype.componentDidMount = function () {
        var _this = this;
        this.input.addEventListener('animationstart', function (e) {
            if (e.animationName === s.onAutoFillStart) {
                _this.setState({ isAutofilled: true });
            }
            else if (e.animationName === s.onAutoFillCancel) {
                _this.setState({ isAutofilled: false });
            }
        });
        // the next should hopefully be not needed
        // when browsers' autofill makes it to React API:
        // https://github.com/facebook/react/issues/11097
        if (this.props.autoComplete !== 'off') {
            this.checkForBrowserAutofill();
        }
    };
    Input.prototype.render = function () {
        var props = this.props;
        var state = this.state;
        return (React.createElement(InputLayout, { id: props.id, label: props.label, isFocused: state.isFocused, isFilled: state.isFocused || !!props.value, hasPlaceholder: !!props.placeholder, hasError: this.hasError(), errorMessage: props.errorMessage, showHintOnFocus: props.showHintOnFocus, hint: props.hint, success: props.success, loading: props.loading, readOnly: props.readOnly, prefixIcon: props.prefixIcon, withFadedPrefixIcon: props.withFilledBackground, suffix: props.suffix, className: classnames(props.className, this.s('input-layout'), state.isFocused && !props.readOnly && this.s('focused'), props.prefixIcon && this.s('has-prefix-icon'), props.withFilledBackground && this.s('filled-background')), textUnderClassName: props.textUnderClassName, fullWidth: props.fullWidth, withPaddings: !props.withFilledBackground, withBar: !props.withFilledBackground, skin: props.skin, onClick: props.onClick },
            this.renderBeforeInput(),
            React.createElement(BiInput, { id: props.id, name: props.name, type: props.type, className: classnames(this.s('input'), props.inputClassName), value: props.value, placeholder: !props.value ? props.placeholder : undefined, pattern: props.pattern, autoFocus: props.autoFocus, readOnly: props.readOnly, autoComplete: props.autoComplete, autoCapitalize: props.autoCapitalize, spellCheck: props.spellCheck, onFocus: this.onFocus, onBlur: this.onBlur, onChange: this.onChange, onInput: this.onChange, onKeyPress: props.onKeyPress, onKeyDown: props.onKeyDown, onKeyUp: this.onKeyUp, max: props.maxValue, min: props.minValue, step: props.step, maxLength: props.maxLength, innerRef: this.ref, tabIndex: props.tabIndex, defaultValue: props.defaultValue, "aria-autocomplete": props['aria-autocomplete'], "aria-activedescendant": props['aria-activedescendant'], "aria-controls": props['aria-controls'], biData: props.biData }),
            this.renderAfterInput()));
    };
    Input.prototype.renderBeforeInput = function () {
        return this.props.beforeInput;
    };
    Input.prototype.renderAfterInput = function () {
        var _this = this;
        var afterInput = this.props.afterInput;
        return (React.createElement(MobileContext.Consumer, null, function (isMobile) { return (React.createElement(React.Fragment, null,
            afterInput,
            _this.renderCharactersRemainingCounter(),
            !isMobile && _this.renderNumberControls())); }));
    };
    Input.prototype.hasError = function () {
        var _a = this.props, error = _a.error, errorMessage = _a.errorMessage;
        return error || !!errorMessage;
    };
    Input.prototype.renderCharactersRemainingCounter = function () {
        var _a = this.props, maxLength = _a.maxLength, type = _a.type, _b = _a.value, value = _b === void 0 ? '' : _b, showRemainingCharacters = _a.showRemainingCharacters;
        if (!maxLength || type !== 'text' || !showRemainingCharacters) {
            return null;
        }
        var charactersRemaining = maxLength - value.length;
        return (React.createElement("span", { className: this.s('symbols-left') }, charactersRemaining));
    };
    Input.prototype.renderNumberControls = function () {
        return this.props.type === 'number' ? (React.createElement("div", { className: s['number-controls'] },
            React.createElement("span", { onClick: this.handleIncrement, className: s['increment-button'] },
                React.createElement(IconArrowUp, { size: IconSize.TINY })),
            React.createElement("span", { onClick: this.handleDecrement, className: s['decrement-button'] },
                React.createElement(IconArrowDown, { size: IconSize.TINY })))) : null;
    };
    Input.defaultProps = {
        type: 'text',
        spellCheck: true,
        showRemainingCharacters: true,
        skin: {},
    };
    return Input;
}(React.Component));
export default Input;
//# sourceMappingURL=Input.js.map